import { Tooltip } from 'bootstrap';

// ─── Constants ───────────────────────────────────────────────────────────────
const MAX_ROWS = 20;
const WORKER_ALL_VALUE = 'all';
const SELECT2_LANGUAGE = {
  noResults: function () { return '見つかりません。'; },
  searching: function () { return '検索中...'; },
  errorLoading: function () { return '結果を取得できませんでした。'; }
};
let $pendingDeleteRow = null;

// ─── Data URLs ───────────────────────────────────────────────────────────────
function activitySectionWrap() {
  var $wrap = $('#daily-report-form .activity-section-wrap').first();
  return $wrap.length ? $wrap : $('.activity-section-wrap').first();
}

function getClientCompaniesUrl() {
  var $wrap = activitySectionWrap();
  return $wrap.attr('data-client-companies-url') ||
         $wrap.data('clientCompaniesUrl') ||
         $wrap.data('client-companies-url');
}
function getProjectsUrl() {
  var $wrap = activitySectionWrap();
  return $wrap.attr('data-projects-url') ||
         $wrap.data('projectsUrl') ||
         $wrap.data('projects-url');
}
function getCaseNamesUrl() {
  var $wrap = activitySectionWrap();
  return $wrap.attr('data-case-names-url') ||
         $wrap.data('caseNamesUrl') ||
         $wrap.data('case-names-url');
}

// PJ dropdown is filtered by 案件完了日 vs this report date (server-side).
function getReportAtValue() {
  return $('#report_at').val() || '';
}

function hasAjaxSelect2($el) {
  if (!$el || !$el.length) return false;
  var s2 = $el.data('select2');
  if (!s2) return false;
  var opts = s2.options && s2.options.options;
  return !!(opts && opts.ajax);
}

// ─── Select2 helpers ─────────────────────────────────────────────────────────
function applySelect2($el, placeholder) {
  if (!$el.length) return;
  if ($el.hasClass('select2-hidden-accessible')) $el.select2('destroy');
  $el.select2({
    width: '100%',
    theme: 'bootstrap',
    placeholder: placeholder || '選択してください',
    allowClear: true,
    language: SELECT2_LANGUAGE
  });
}

function applyAjaxSelect2($el, url, placeholder, selectedId, selectedText) {
  if (!$el.length) return;
  if (!url) {
    // Still paint Select2 UI so the field never falls back to a native <select>,
    // but without ajax it cannot load 顧客名 — caller should ensure URL exists.
    applySelect2($el, placeholder);
    return;
  }
  if ($el.hasClass('select2-hidden-accessible')) $el.select2('destroy');

  // Keep current selection if present; otherwise restore from args
  var currentVal = $el.val();
  var currentText = $el.find('option:selected').text();
  if (selectedId && selectedText) {
    $el.empty().append(new Option(selectedText, selectedId, true, true));
  } else if (currentVal && currentText) {
    // Preserve in-memory selection across re-inits
    $el.empty().append(new Option(currentText, currentVal, true, true));
  }

  $el.select2({
    width: '100%',
    theme: 'bootstrap',
    placeholder: placeholder || '選択してください',
    allowClear: true,
    minimumInputLength: 0,
    ajax: {
      url: url,
      dataType: 'json',
      delay: 250,
      data: function (params) { return { q: params.term || '', for: 'form', report_at: getReportAtValue() }; },
      processResults: function (data) {
        // Support both { results: [...] } and bare array
        if (Array.isArray(data)) return { results: data };
        return data;
      },
      cache: true
    },
    language: SELECT2_LANGUAGE
  });
}

function ensureClientAjaxSelect2($row) {
  var $client = $row.find('.dr-client-select');
  if (!$client.length || hasAjaxSelect2($client)) return;

  var clientId   = $row.attr('data-client-company-id') || $row.data('clientCompanyId') || null;
  var clientText = $row.attr('data-client-company-name') || $row.data('clientCompanyName') || null;
  if (clientId === '') clientId = null;
  if (clientText === '') clientText = null;

  applyAjaxSelect2(
    $client,
    getClientCompaniesUrl(),
    '選択してください',
    clientId,
    clientText
  );
}

function fillSelect($el, options, selectedId, placeholder) {
  if (!$el.length) return;
  var wasDisabled = $el.prop('disabled');
  $el.prop('disabled', false);
  $el.empty().append('<option value=""></option>');
  (options || []).forEach(function (o) {
    var $opt = $('<option>').val(o.id).text(o.name || o.text);
    if (o.type) $opt.attr('data-type', o.type);
    $el.append($opt);
  });
  if (selectedId) $el.val(String(selectedId));
  applySelect2($el, placeholder);
  if (wasDisabled && !selectedId) $el.prop('disabled', true);
}

// ─── Snapshot / restore (protect existing rows when adding) ──────────────────
function snapshotRow($row) {
  var $client = $row.find('.dr-client-select');
  var $pj = $row.find('.dr-pj-select');
  var $case = $row.find('.dr-case-select');
  var $actType = $row.find('.dr-activity-type-select');

  return {
    clientId: $client.val() || null,
    clientText: $client.find('option:selected').text() || null,
    pjId: $pj.val() || null,
    pjOptions: $pj.find('option').map(function () {
      return { id: this.value, name: $(this).text() };
    }).get().filter(function (o) { return o.id !== ''; }),
    caseId: $case.val() || null,
    caseOptions: $case.find('option').map(function () {
      return {
        id: this.value,
        name: $(this).text(),
        type: $(this).attr('data-type') || null
      };
    }).get().filter(function (o) { return o.id !== ''; }),
    actTypeId: $actType.val() || null,
    projectHidden: $row.find('.dr-project-id-hidden').val() || '',
    estimateHidden: $row.find('.dr-estimate-sheet-id-hidden').val() || '',
    orderedHidden: $row.find('.dr-ordered-item-id-hidden').val() || '',
    hours: $row.find('.dr-hours').val(),
    minuts: $row.find('.dr-minuts').val(),
    content: $row.find('.dr-content').val()
  };
}

function restoreRow($row, snap) {
  if (!snap) return;

  $row.data('dr-loading', true);

  if (snap.clientId) {
    applyAjaxSelect2(
      $row.find('.dr-client-select'),
      getClientCompaniesUrl(),
      '選択してください',
      snap.clientId,
      snap.clientText
    );
  }

  if (snap.pjOptions && snap.pjOptions.length) {
    fillSelect($row.find('.dr-pj-select'), snap.pjOptions, snap.pjId, 'データがありません。');
    $row.find('.dr-pj-select').prop('disabled', false);
  }

  if (snap.caseOptions && snap.caseOptions.length) {
    fillSelect($row.find('.dr-case-select'), snap.caseOptions, snap.caseId, '選択してください');
    $row.find('.dr-case-select').prop('disabled', false);
  }

  if (snap.actTypeId) {
    var $actType = $row.find('.dr-activity-type-select');
    $actType.val(snap.actTypeId);
    if ($actType.hasClass('select2-hidden-accessible')) {
      $actType.trigger('change.select2');
    }
  }

  $row.find('.dr-project-id-hidden').val(snap.projectHidden);
  $row.find('.dr-estimate-sheet-id-hidden').val(snap.estimateHidden);
  $row.find('.dr-ordered-item-id-hidden').val(snap.orderedHidden);
  if (snap.hours !== undefined) $row.find('.dr-hours').val(snap.hours);
  if (snap.minuts !== undefined) $row.find('.dr-minuts').val(snap.minuts);
  if (snap.content !== undefined) $row.find('.dr-content').val(snap.content);

  $row.data('dr-loading', false);
}

function snapshotAllRows() {
  var snaps = [];
  $('#new-daily-report-form .nested-fields:visible').each(function () {
    snaps.push({ $row: $(this), data: snapshotRow($(this)) });
  });
  return snaps;
}

function restoreAllRows(snaps) {
  snaps.forEach(function (s) {
    // Skip rows that were not yet initialized / newly added without data
    if (!s.$row.data('dr-initialized')) return;
    restoreRow(s.$row, s.data);
  });
}

// ─── Row initialisation ──────────────────────────────────────────────────────
function initRow($row) {
  if (!$row || !$row.length) return;

  // Already wired: only repair 顧客名 if AJAX Select2 was wiped / never attached
  if ($row.data('dr-initialized')) {
    ensureClientAjaxSelect2($row);
    return;
  }

  $row.data('dr-initialized', true);
  $row.data('dr-loading', true);

  // 作業種別
  var $actType = $row.find('.dr-activity-type-select');
  if ($actType.hasClass('select2-hidden-accessible')) $actType.select2('destroy');
  $actType.select2({
    width: '100%',
    theme: 'bootstrap',
    placeholder: '選択してください',
    allowClear: true,
    language: SELECT2_LANGUAGE
  });

  // 顧客名 — AJAX
  ensureClientAjaxSelect2($row);

  var clientId      = $row.attr('data-client-company-id') || $row.data('clientCompanyId') || null;
  var projectId     = $row.attr('data-project-id') || $row.data('project-id') || null;
  var savedCaseId   = $row.attr('data-case-id') || $row.data('case-id') || null;
  var savedCaseType = $row.attr('data-case-type') || $row.data('case-type') || null;
  if (clientId === '') clientId = null;
  if (projectId === '') projectId = null;
  if (savedCaseId === '') savedCaseId = null;
  if (savedCaseType === '') savedCaseType = null;

  if (projectId) {
    $.get(getProjectsUrl(), { client_company_id: clientId, for: 'form', report_at: getReportAtValue() }, function (pjs) {
      fillSelect($row.find('.dr-pj-select'), pjs, projectId, 'データがありません。');
      $row.find('.dr-pj-select').prop('disabled', false);

      $.get(getCaseNamesUrl(), { project_id: projectId, for: 'form' }, function (cases) {
        fillSelect($row.find('.dr-case-select'), cases, savedCaseId, '選択してください');
        $row.find('.dr-case-select').prop('disabled', false);
        if (savedCaseId && savedCaseType) {
          setCaseHiddenFields($row, savedCaseId, savedCaseType);
        }
        $row.data('dr-loading', false);
        initSelect2Tooltips($row);
      }).fail(function () { $row.data('dr-loading', false); });
    }).fail(function () { $row.data('dr-loading', false); });
  } else {
    applySelect2($row.find('.dr-pj-select'), 'データがありません。');
    applySelect2($row.find('.dr-case-select'), '選択してください');
    $row.find('.dr-pj-select').prop('disabled', true);
    $row.find('.dr-case-select').prop('disabled', true);
    $row.data('dr-loading', false);
    initSelect2Tooltips($row);
  }

  bindRowEvents($row);
  initDailyReportTooltips($row);
  initSelect2Tooltips($row);
}

// ─── Cascade event binding ───────────────────────────────────────────────────
function bindRowEvents($row) {
  var ns = '.dr-cascade';

  $row.find('.dr-client-select').off(ns).on('change' + ns, function () {
    if ($row.data('dr-loading')) return;
    var clientId = $(this).val() || null;
    var clientText = $(this).find('option:selected').text() || '';

    // Persist to data attrs so future restores work
    $row.attr('data-client-company-id', clientId || '');
    $row.attr('data-client-company-name', clientText);
    $row.attr('data-project-id', '');
    $row.attr('data-case-id', '');
    $row.attr('data-case-type', '');

    clearField($row.find('.dr-pj-select'), 'データがありません。');
    clearField($row.find('.dr-case-select'), '選択してください');
    $row.find('.dr-project-id-hidden').val('');
    clearCaseHiddenFields($row);

    if (!clientId) {
      $row.find('.dr-pj-select').prop('disabled', true);
      $row.find('.dr-case-select').prop('disabled', true);
      return;
    }

    $row.find('.dr-pj-select').prop('disabled', true);
    $.get(getProjectsUrl(), { client_company_id: clientId, for: 'form', report_at: getReportAtValue() }, function (pjs) {
      fillSelect($row.find('.dr-pj-select'), pjs, null, 'データがありません。');
      $row.find('.dr-pj-select').prop('disabled', false);
      $row.find('.dr-case-select').prop('disabled', true);
    });
  });

  $row.find('.dr-pj-select').off(ns).on('change' + ns, function () {
    if ($row.data('dr-loading')) return;
    var projectId = $(this).val() || null;

    $row.attr('data-project-id', projectId || '');
    $row.attr('data-case-id', '');
    $row.attr('data-case-type', '');

    clearField($row.find('.dr-case-select'), '選択してください');
    $row.find('.dr-project-id-hidden').val(projectId || '');
    clearCaseHiddenFields($row);

    if (!projectId) {
      $row.find('.dr-case-select').prop('disabled', true);
      return;
    }

    $row.find('.dr-case-select').prop('disabled', true);
    $.get(getCaseNamesUrl(), { project_id: projectId, for: 'form' }, function (cases) {
      fillSelect($row.find('.dr-case-select'), cases, null, '選択してください');
      $row.find('.dr-case-select').prop('disabled', false);
    });
  });

  $row.find('.dr-case-select').off(ns).on('change' + ns, function () {
    if ($row.data('dr-loading')) return;
    var caseId = $(this).val() || null;
    if (!caseId) {
      $row.attr('data-case-id', '');
      $row.attr('data-case-type', '');
      clearCaseHiddenFields($row);
      return;
    }
    var caseType = $row.find('.dr-case-select option:selected').attr('data-type') || null;
    $row.attr('data-case-id', caseId);
    $row.attr('data-case-type', caseType || '');
    setCaseHiddenFields($row, caseId, caseType);
  });

  $row.find('.btn-delete-activity').off(ns).on('click' + ns, function () {
    $pendingDeleteRow = $row;
    $('#delete-activity-modal').modal('show');
  });

  $row.find('.btn-copy-activity').off(ns).on('click' + ns, function (e) {
    e.preventDefault();
    copyActivityRow($row);
  });
}

// Copy an activity row — insert new row below the source row with only
// client name, PJ, and case name copied; reset all other fields to default.
function copyActivityRow($sourceRow) {
  if (!$sourceRow || !$sourceRow.length) return;
  if (visibleRowCount() >= MAX_ROWS) {
    updateAddRowButton();
    return;
  }

  // Snapshot data from the source row (顧客名, PJ, 見積案件/受注案件)
  var clientId = $sourceRow.find('.dr-client-select').val() || null;
  var clientText = $sourceRow.find('.dr-client-select option:selected').text() || null;
  var pjId = $sourceRow.find('.dr-pj-select').val() || null;
  var pjOptions = $sourceRow.find('.dr-pj-select option').map(function () {
    return { id: this.value, name: $(this).text() };
  }).get().filter(function (o) { return o.id !== ''; });
  var caseId = $sourceRow.find('.dr-case-select').val() || null;
  var caseOptions = $sourceRow.find('.dr-case-select option').map(function () {
    return {
      id: this.value,
      name: $(this).text(),
      type: $(this).attr('data-type') || null
    };
  }).get().filter(function (o) { return o.id !== ''; });
  var caseType = $sourceRow.find('.dr-case-select option:selected').attr('data-type') || null;
  var projectHidden = $sourceRow.find('.dr-project-id-hidden').val() || '';
  var estimateHidden = $sourceRow.find('.dr-estimate-sheet-id-hidden').val() || '';
  var orderedHidden = $sourceRow.find('.dr-ordered-item-id-hidden').val() || '';

  // Flag to identify that this is a copy operation
  window._drCopyData = {
    clientId: clientId,
    clientText: clientText,
    pjId: pjId,
    pjOptions: pjOptions,
    caseId: caseId,
    caseOptions: caseOptions,
    caseType: caseType,
    projectHidden: projectHidden,
    estimateHidden: estimateHidden,
    orderedHidden: orderedHidden,
    insertAfter: $sourceRow
  };

  // Insert from Cocoon's template directly. Do NOT $addBtn.trigger('click'):
  // that synthetic jQuery event does not reach Cocoon's handler on develop
  // (separate jQuery instance / pack), so copy does nothing while 行追加
  // (real click) and 削除 (direct JS) still work.
  var $row = buildActivityRowFromTemplate();
  if ($row && $row.length) {
    $sourceRow.after($row);
    afterActivityRowInserted($row);
    return;
  }

  var $addBtn = $('#dr-add-row-wrap .add_fields').first();
  if ($addBtn.length && $addBtn[0].click) $addBtn[0].click();
}

// Build a new activity row the same way Cocoon does, without going through click.
function buildActivityRowFromTemplate() {
  var $addBtn = $('#dr-add-row-wrap .add_fields').first();
  if (!$addBtn.length) return $();

  var assoc = $addBtn.attr('data-association') || $addBtn.data('association');
  var assocs = $addBtn.attr('data-associations') || $addBtn.data('associations');
  var content = $addBtn.attr('data-association-insertion-template') ||
                $addBtn.data('association-insertion-template');
  if (!content || !assoc) return $();

  // data-* attributes are HTML-escaped; textarea trick matches browser decoding
  if (typeof content === 'string' && content.indexOf('&') !== -1) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = content;
    content = textarea.value;
  }

  var regexpBraced = new RegExp('\\[new_' + assoc + '\\](.*?\\s)', 'g');
  var regexpUnderscord = new RegExp('_new_' + assoc + '_(\\w*)', 'g');
  var newId = new Date().getTime();
  var newContent = content.replace(regexpBraced, '[' + newId + ']$1');
  if (newContent === content && assocs) {
    regexpBraced = new RegExp('\\[new_' + assocs + '\\](.*?\\s)', 'g');
    regexpUnderscord = new RegExp('_new_' + assocs + '_(\\w*)', 'g');
    newContent = content.replace(regexpBraced, '[' + newId + ']$1');
  }
  newContent = newContent.replace(regexpUnderscord, '_' + newId + '_$1');

  var $row = $(newContent);
  if (!$row.hasClass('nested-fields')) {
    $row = $row.find('.nested-fields').addBack('.nested-fields').first();
  }
  return $row;
}

// Mark nested activity for destruction without relying on Cocoon's
// `$link.prev("input[type=hidden]")` lookup (can miss SimpleForm markup).
function removeActivityRow($row) {
  if (!$row || !$row.length) return;

  var $removeLink = $row.find('.dr-cocoon-remove');
  var $destroy = $row.find('input[name*="[_destroy]"]');
  var isDynamic = $removeLink.hasClass('dynamic');

  if (isDynamic || !$destroy.length) {
    $row.remove();
  } else {
    $destroy.val('1');
    $row.hide();
  }
  updateAddRowButton();
  updateSaveButtonState();
  updateTotalTime();
}

// Safety net: any visually removed row must not be saved as a normal record.
function syncDestroyedActivityRows() {
  $('#new-daily-report-form .nested-fields').each(function () {
    var $row = $(this);
    if ($row.is(':visible')) return;

    var $destroy = $row.find('input[name*="[_destroy]"]');
    if ($destroy.length) {
      $destroy.val('1');
    } else {
      $row.remove();
    }
  });
}

// ─── Case hidden field helpers ────────────────────────────────────────────────
function setCaseHiddenFields($row, caseId, caseType) {
  if (caseType === 'ordered_item') {
    $row.find('.dr-ordered-item-id-hidden').val(caseId);
    $row.find('.dr-estimate-sheet-id-hidden').val('');
  } else if (caseType === 'estimate_sheet') {
    $row.find('.dr-estimate-sheet-id-hidden').val(caseId);
    $row.find('.dr-ordered-item-id-hidden').val('');
  }
}

function clearCaseHiddenFields($row) {
  $row.find('.dr-estimate-sheet-id-hidden').val('');
  $row.find('.dr-ordered-item-id-hidden').val('');
}

function clearField($select, placeholder) {
  if (!$select.length) return;
  $select.empty().append('<option value=""></option>');
  if ($select.hasClass('select2-hidden-accessible')) $select.select2('destroy');
  $select.select2({
    width: '100%',
    theme: 'bootstrap',
    placeholder: placeholder || '選択してください',
    allowClear: true,
    language: SELECT2_LANGUAGE
  });
}

// ─── Row count / add-row button ───────────────────────────────────────────────
function visibleRowCount() {
  return $('#new-daily-report-form .nested-fields:visible').length;
}

function updateAddRowButton() {
  var $wrap = $('#dr-add-row-wrap');
  if (visibleRowCount() >= MAX_ROWS) {
    $wrap.addClass('d-none');
  } else {
    $wrap.removeClass('d-none');
  }
}

// ─── 作業時間: allow half-width & full-width digits ───────────────────────────
function toHalfWidthDigits(value) {
  return String(value || '').replace(/[０-９]/g, function (ch) {
    return String.fromCharCode(ch.charCodeAt(0) - 0xFEE0);
  });
}

function normalizeTimeInputValue($input) {
  var raw = $input.val();
  var half = toHalfWidthDigits(raw).replace(/[^\d]/g, '');
  if (half !== raw) $input.val(half);
  return half;
}

function normalizeAllTimeInputs($scope) {
  ($scope || $(document)).find('.dr-time-input').each(function () {
    normalizeTimeInputValue($(this));
  });
}

var MAX_HOURS = 12;
var MAX_MINUTS = 59;

function parseTimeNumber(value) {
  var half = toHalfWidthDigits(value).replace(/[^\d]/g, '');
  if (half === '') return null;
  var n = parseInt(half, 10);
  return isNaN(n) ? null : n;
}

function validateRowTimeRange($row) {
  var hoursVal = $row.find('.dr-hours').val();
  var minutsVal = $row.find('.dr-minuts').val();
  var hours = parseTimeNumber(hoursVal);
  var minuts = parseTimeNumber(minutsVal);
  var hoursEmpty = hoursVal === '' || hoursVal === null;
  var hoursInvalid = !hoursEmpty && hours !== null && hours > MAX_HOURS;
  var minutsInvalid = minuts !== null && minuts > MAX_MINUTS;
  var invalid = hoursInvalid || minutsInvalid;

  $row.find('.dr-time-range-error').toggleClass('d-none', !invalid);
  $row.find('.dr-hours').toggleClass('dr-is-invalid', hoursInvalid);
  $row.find('.dr-minuts').toggleClass('dr-is-invalid', minutsInvalid);

  return !invalid;
}

function validateRowTimeFields($row) {
  var hoursVal = $row.find('.dr-hours').val();
  var hoursEmpty = hoursVal === '' || hoursVal === null;
  var $requiredError = $row.find('.dr-time-required-error');
  var valid = validateRowTimeRange($row);

  if (hoursEmpty) {
    $requiredError.removeClass('d-none');
    valid = false;
  } else {
    $requiredError.addClass('d-none');
  }

  return valid;
}

function hasTimeRangeErrors() {
  var invalid = false;
  $('#new-daily-report-form .nested-fields:visible').each(function () {
    var $row = $(this);
    var hours = parseTimeNumber($row.find('.dr-hours').val());
    var minuts = parseTimeNumber($row.find('.dr-minuts').val());
    if ((hours !== null && hours > MAX_HOURS) || (minuts !== null && minuts > MAX_MINUTS)) {
      invalid = true;
      return false;
    }
  });
  return invalid;
}

function updateSaveButtonState() {
  var $btn = $('#dr-save-btn');
  if (!$btn.length) return;
  $btn.prop('disabled', hasTimeRangeErrors());
}

// ─── Total time calculation ───────────────────────────────────────────────────
function calculateTotalTime() {
  var totalMinuts = 0;

  $('#new-daily-report-form .nested-fields:visible').each(function () {
    var $row = $(this);
    var hours = parseTimeNumber($row.find('.dr-hours').val()) || 0;
    var minuts = parseTimeNumber($row.find('.dr-minuts').val()) || 0;

    totalMinuts += (hours * 60) + minuts;
  });

  var displayHours = Math.floor(totalMinuts / 60);
  var displayMinuts = totalMinuts % 60;

  $('#dr-total-hours').text(displayHours);
  $('#dr-total-minuts').text(displayMinuts);
}

function updateTotalTime() {
  calculateTotalTime();
}

// ─── Client-side validation ───────────────────────────────────────────────────
function validateForm() {
  var valid = true;
  normalizeAllTimeInputs($('#new-daily-report-form'));

  var reportAt = $('#report_at').val();
  if (!reportAt) {
    $('#report_at').addClass('is-invalid');
    valid = false;
  } else {
    $('#report_at').removeClass('is-invalid');
  }

  $('#new-daily-report-form .nested-fields:visible').each(function () {
    var $row = $(this);

    if (!validateCascadeField($row, '.dr-client-select', '.col-dr-client')) valid = false;
    if (!validateCascadeField($row, '.dr-pj-select', '.col-dr-pj'))         valid = false;
    $row.find('.col-dr-case .dr-field-error').addClass('d-none');

    if (!validateRowTimeFields($row)) valid = false;

    $row.find('.col-dr-type .dr-field-error, .col-dr-content .dr-field-error').addClass('d-none');
  });

  updateSaveButtonState();
  return valid;
}

function validateCascadeField($row, selectSelector, colSelector) {
  var val = $row.find(selectSelector).val();
  var $err = $row.find(colSelector + ' .dr-field-error');
  if (!val) {
    $err.removeClass('d-none');
    return false;
  }
  $err.addClass('d-none');
  return true;
}

// Init every activity row that has not been wired yet (idempotent via dr-initialized)
function initUninitializedRows() {
  $('#new-daily-report-form .nested-fields').each(function () {
    initRow($(this));
  });
}

function resolveInsertedRow(item) {
  var $inserted = $(item);
  if (!$inserted.length) return $();
  if ($inserted.hasClass('nested-fields')) return $inserted;
  var $closest = $inserted.closest('.nested-fields');
  if ($closest.length) return $closest;
  return $inserted.find('.nested-fields').first();
}

function afterActivityRowInserted(item) {
  var $row = resolveInsertedRow(item);
  // Capture before clearing — restoreAllRows must be skipped for copy,
  // otherwise the snapshot taken in before-insert overwrites the new row.
  var copyData = window._drCopyData;
  var isCopy = !!(copyData && copyData.insertAfter);

  if ($row.length && $row.closest('#new-daily-report-form').length) {
    if (isCopy) {
      // Move the newly created row to be immediately after the source row
      copyData.insertAfter.after($row);
      window._drCopyData = null;
      window._drRowSnapshots = null;

      // Persist cascade ids before init so AJAX Select2 restore has a source
      $row.attr('data-client-company-id', copyData.clientId || '');
      $row.attr('data-client-company-name', copyData.clientText || '');
      $row.attr('data-project-id', copyData.pjId || '');
      $row.attr('data-case-id', copyData.caseId || '');
      $row.attr('data-case-type', copyData.caseType || '');

      // Initialize the row
      initRow($row);

      // Populate the copied fields (顧客名, PJ, 見積案件/受注案件)
      setTimeout(function () {
        $row.data('dr-loading', true);

        // 顧客名
        if (copyData.clientId && copyData.clientText) {
          applyAjaxSelect2(
            $row.find('.dr-client-select'),
            getClientCompaniesUrl(),
            '選択してください',
            copyData.clientId,
            copyData.clientText
          );
        }

        // PJ
        if (copyData.pjOptions && copyData.pjOptions.length) {
          fillSelect($row.find('.dr-pj-select'), copyData.pjOptions, copyData.pjId, 'データがありません。');
          $row.find('.dr-pj-select').prop('disabled', false);
        }

        // 見積案件/受注案件
        if (copyData.caseOptions && copyData.caseOptions.length) {
          fillSelect($row.find('.dr-case-select'), copyData.caseOptions, copyData.caseId, '選択してください');
          $row.find('.dr-case-select').prop('disabled', false);
        }

        // Hidden fields
        $row.find('.dr-project-id-hidden').val(copyData.projectHidden);
        $row.find('.dr-estimate-sheet-id-hidden').val(copyData.estimateHidden);
        $row.find('.dr-ordered-item-id-hidden').val(copyData.orderedHidden);

        $row.data('dr-loading', false);
        initDailyReportTooltips($row);
        initSelect2Tooltips($row);
      }, 100);
    } else {
      // Normal row insertion (not a copy)
      initRow($row);
    }
  }
  initUninitializedRows();
  updateAddRowButton();
  updateTotalTime();

  // Restore any existing rows that may have been wiped by global handlers (only if not a copy)
  if (!isCopy) {
    var snaps = window._drRowSnapshots || [];
    setTimeout(function () {
      restoreAllRows(snaps);
      initUninitializedRows();
      window._drRowSnapshots = null;
      initDailyReportTooltips($('#daily-report-form'));
      initSelect2Tooltips($('#daily-report-form'));
    }, 80);
  }
}

// ─── Horizontal Enter key navigation (table-specific) ────────────────────────
function isEnterKey(event) {
  return event.key === 'Enter' || event.which === 13 || event.keyCode === 13;
}

function isImeComposing(event) {
  var originalEvent = event.originalEvent || event;
  return originalEvent.isComposing === true ||
    originalEvent.keyCode === 229 ||
    originalEvent.which === 229;
}

function getRowInputFields($row) {
  // Left-to-right editable fields in a daily report activity row
  return [
    $row.find('.dr-client-select')[0],
    $row.find('.dr-pj-select')[0],
    $row.find('.dr-case-select')[0],
    $row.find('.dr-hours')[0],
    $row.find('.dr-minuts')[0],
    $row.find('.dr-activity-type-select')[0],
    $row.find('.dr-content')[0]
  ].filter(Boolean);
}

function isFieldFocusable(el) {
  if (!el) return false;
  var $el = $(el);
  if ($el.prop('disabled')) return false;
  // Hidden native <select> used by Select2 is still focusable via Select2 UI
  if ($el.hasClass('select2-hidden-accessible')) return true;
  return $el.is(':visible');
}

function getAddRowButton() {
  var $wrap = $('#dr-add-row-wrap');
  if (!$wrap.length || $wrap.hasClass('d-none')) return $();
  return $wrap.find('.add_fields').first();
}

// Map Select2 UI / nested inputs back to the underlying row field element
function resolveTableFieldElement(target) {
  var $target = $(target);
  if (!$target.length) return $();

  if ($target.is('select, input, textarea') && $target.closest('.nested-fields').length) {
    return $target;
  }

  var $container = $target.closest('.select2-container');
  if ($container.length) {
    var $select = $container.prev('select.select2-hidden-accessible');
    if ($select.length && $select.closest('#new-daily-report-form .nested-fields').length) {
      return $select;
    }
  }

  return $();
}

function isSelect2DropdownOpen($field) {
  if (!$field || !$field.length) return false;
  if ($field.hasClass('select2-search__field')) return true;
  if (!$field.hasClass('select2-hidden-accessible') || !$field.data('select2')) return false;
  return !!$field.data('select2').isOpen();
}

function focusField($field) {
  if (!$field || !$field.length) return;

  if ($field.hasClass('select2-hidden-accessible') && $field.data('select2')) {
    $field.select2('open');
    setTimeout(function () {
      var $searchInput = $('.select2-container--open .select2-search__field').last();
      if ($searchInput.length) $searchInput.focus();
    }, 0);
    return;
  }

  setTimeout(function () {
    $field.focus();
    if ($field.is('input, textarea') && typeof $field[0].select === 'function') {
      try { $field[0].select(); } catch (e) { /* ignore */ }
    }
  }, 0);
}

function focusFirstFieldInRow($row) {
  var fields = getRowInputFields($row);
  for (var i = 0; i < fields.length; i++) {
    if (isFieldFocusable(fields[i])) {
      focusField($(fields[i]));
      return true;
    }
  }
  return false;
}

function focusNextFieldInRow($currentField) {
  var $field = resolveTableFieldElement($currentField[0] || $currentField);
  if (!$field.length) $field = $currentField;

  var $row = $field.closest('.nested-fields');
  if (!$row.length || !$row.closest('#new-daily-report-form').length) return false;

  var fields = getRowInputFields($row);
  var currentIndex = -1;
  var currentEl = $field[0];

  for (var i = 0; i < fields.length; i++) {
    if (fields[i] === currentEl) {
      currentIndex = i;
      break;
    }
  }
  if (currentIndex === -1) return false;

  // Move right within the same row (skip disabled)
  for (var j = currentIndex + 1; j < fields.length; j++) {
    if (isFieldFocusable(fields[j])) {
      focusField($(fields[j]));
      return true;
    }
  }

  // Last column (内容): next row's 顧客名, or 行追加 on the last row
  var $allRows = $('#new-daily-report-form .nested-fields:visible');
  var currentRowIndex = $allRows.index($row);

  if (currentRowIndex > -1 && currentRowIndex < $allRows.length - 1) {
    return focusFirstFieldInRow($allRows.eq(currentRowIndex + 1));
  }

  var $addBtn = getAddRowButton();
  if ($addBtn.length) {
    $addBtn.focus();
    return true;
  }

  return false;
}

function stopEnterEvent(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
}

function handleDailyReportTableEnter(event) {
  if (!isEnterKey(event) || isImeComposing(event)) return;

  var $target = $(event.target);

  // Let Select2 handle Enter while its dropdown is open (select highlighted option)
  if ($target.hasClass('select2-search__field')) return;

  var $field = resolveTableFieldElement($target);
  if (!$field.length) return;
  if (!$field.closest('#new-daily-report-form .nested-fields').length) return;

  // While dropdown is open, do not navigate / submit
  if (isSelect2DropdownOpen($field)) return;

  stopEnterEvent(event);
  focusNextFieldInRow($field);
}

// ─── Document ready ───────────────────────────────────────────────────────────
$(document).ready(function () {
  var $formList = $('#new-daily-report-form');
  if (!$formList.length) return;

  // Capture-phase Enter: horizontal table navigation + never submit from table fields
  var formElement = document.getElementById('daily-report-form');
  if (formElement) {
    formElement.addEventListener('keydown', handleDailyReportTableEnter, true);
    formElement.addEventListener('keypress', function (event) {
      if (!isEnterKey(event) || isImeComposing(event)) return;
      var $target = $(event.target);
      if ($target.hasClass('select2-search__field')) return;
      if (!resolveTableFieldElement($target).length) return;
      stopEnterEvent(event);
    }, true);

    // Enter outside the table must not submit (Save button remains the only submit path)
    formElement.addEventListener('keydown', function (event) {
      if (!isEnterKey(event) || isImeComposing(event)) return;
      var $target = $(event.target);
      if ($target.is('textarea') || $target.hasClass('select2-search__field')) return;
      if ($target.is('button[type="submit"], input[type="submit"], #dr-save-btn')) return;
      if ($target.closest('#dr-add-row-wrap .add_fields').length) return;
      event.preventDefault();
    }, true);
  }

  initUninitializedRows();
  updateAddRowButton();
  updateTotalTime();
  initDailyReportTooltips($('#daily-report-form'));
  initSelect2Tooltips($('#daily-report-form'));

  // Enter on 行追加: create a row and focus its 顧客名
  $(document).on('keydown keypress', '#dr-add-row-wrap .add_fields', function (event) {
    if (!isEnterKey(event) || isImeComposing(event)) return;
    stopEnterEvent(event);
    if (event.type !== 'keydown') return;

    var $addBtn = $(this);
    if (visibleRowCount() >= MAX_ROWS) return;

    window._drFocusNewRow = true;
    $addBtn.trigger('click');
  });

  $formList.on('cocoon:after-insert.dr-enter', function (e, item) {
    if (!window._drFocusNewRow) return;
    window._drFocusNewRow = false;

    setTimeout(function () {
      var $row = resolveInsertedRow(item);
      if ($row.length) focusFirstFieldInRow($row);
    }, 120);
  });

  // Keep Select2 tooltips black (replace native title tooltip)
  $(document).on('select2:select select2:clear change', '#daily-report-form select', function () {
    var $select = $(this);
    setTimeout(function () { syncSelect2Tooltip($select); }, 0);
  });

  // Select2 re-adds native title on hover — strip it before browser shows gray tooltip
  $(document).on('mouseenter', '#daily-report-form .select2-selection__rendered', function (e) {
    var $rendered = $(this);
    var nativeTitle = ($rendered.attr('title') || '').trim();
    $rendered.removeAttr('title');
    $rendered.find('[title]').removeAttr('title');

    var $select = $rendered.closest('.select2-container').prev('select');
    if (!$select.length) return;

    var title = getSelect2DisplayTitle($select, $rendered);
    if (!title && nativeTitle && nativeTitle !== SELECT2_PLACEHOLDER && nativeTitle !== 'Remove all items') {
      title = nativeTitle;
    }

    var el = $rendered[0];
    var tip = Tooltip.getInstance(el);
    if (!title) {
      if (tip) tip.hide();
      return;
    }

    if (!tip) {
      tip = new Tooltip(el, { container: 'body', title: title, trigger: 'manual' });
    } else if (el.getAttribute('data-bs-original-title') !== title) {
      tip.dispose();
      tip = new Tooltip(el, { container: 'body', title: title, trigger: 'manual' });
    }
    tip.show();
  });

  $(document).on('mouseleave', '#daily-report-form .select2-selection__rendered', function () {
    var tip = Tooltip.getInstance(this);
    if (tip) tip.hide();
  });

  // 作業時間: allow full-width & half-width digits; validate max hours/minuts
  $(document).on('input', '#new-daily-report-form .dr-time-input', function () {
    var raw = $(this).val();
    var filtered = String(raw || '').replace(/[^0-9０-９]/g, '');
    if (filtered !== raw) $(this).val(filtered);

    var $row = $(this).closest('.nested-fields');
    validateRowTimeRange($row);
    updateSaveButtonState();
    updateTotalTime();
  });

  $(document).on('blur', '#new-daily-report-form .dr-time-input', function () {
    normalizeTimeInputValue($(this));
    var $row = $(this).closest('.nested-fields');
    validateRowTimeRange($row);
    updateSaveButtonState();
    updateTotalTime();
  });

  // Capture-phase guard: runs before Cocoon's document click handler.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('#dr-add-row-wrap .add_fields');
    if (!btn) return;
    if (visibleRowCount() >= MAX_ROWS) {
      e.preventDefault();
      e.stopImmediatePropagation();
      updateAddRowButton();
    }
  }, true);

  // Bind on the insertion node itself — Cocoon triggers here synchronously
  // after append, so Select2 is wired in the same turn (no setTimeout).
  $formList.off('cocoon:before-insert.dr').on('cocoon:before-insert.dr', function (e) {
    if (visibleRowCount() >= MAX_ROWS) {
      e.preventDefault();
      updateAddRowButton();
      return;
    }
    window._drRowSnapshots = snapshotAllRows();
  });

  $formList.off('cocoon:after-insert.dr').on('cocoon:after-insert.dr', function (e, item) {
    afterActivityRowInserted(item);
  });

  $formList.off('cocoon:after-remove.dr').on('cocoon:after-remove.dr', function () {
    updateAddRowButton();
  });

  // DOM-based fallback: init whenever a .nested-fields row appears in the list.
  // Does not depend on Cocoon event delivery (which can be missed by other handlers).
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var needsInit = false;
      mutations.forEach(function (m) {
        if (!m.addedNodes || !m.addedNodes.length) return;
        for (var i = 0; i < m.addedNodes.length; i++) {
          var node = m.addedNodes[i];
          if (node.nodeType !== 1) continue;
          if ((node.classList && node.classList.contains('nested-fields')) ||
              (node.querySelector && node.querySelector('.nested-fields'))) {
            needsInit = true;
            break;
          }
        }
      });
      if (needsInit) {
        initUninitializedRows();
        updateAddRowButton();
      }
    });
    observer.observe($formList[0], { childList: true, subtree: false });
  }

  // Interaction fallback: if 顧客名 is still a native/plain select, wire AJAX
  // Select2 before the browser opens the native dropdown.
  $(document).off('mousedown.dr-client-ajax', '#new-daily-report-form .dr-client-select')
    .on('mousedown.dr-client-ajax', '#new-daily-report-form .dr-client-select', function (e) {
      var $client = $(this);
      if (hasAjaxSelect2($client)) return;

      e.preventDefault();
      e.stopPropagation();

      var $row = $client.closest('.nested-fields');
      if (!$row.data('dr-initialized')) {
        initRow($row);
      } else {
        ensureClientAjaxSelect2($row);
      }

      if (hasAjaxSelect2($client)) {
        // Open after re-init; must defer so this cancelled native mousedown finishes.
        setTimeout(function () { $client.select2('open'); }, 0);
      }
    });

  $('#dr-confirm-delete-btn').on('click', function () {
    if ($pendingDeleteRow) {
      removeActivityRow($pendingDeleteRow);
      $pendingDeleteRow = null;
    }
    $('#delete-activity-modal').modal('hide');
  });

  $('#dr-save-btn').on('click', function (e) {
    if (!validateForm()) {
      e.preventDefault();
      return false;
    }
  });

  $('#daily-report-form').on('submit', function () {
    syncDestroyedActivityRows();
  });
});

// ─── Tooltips (black Bootstrap tooltip, same as list screen) ─────────────────
var SELECT2_PLACEHOLDER = '選択してください';

function initDailyReportTooltips($scope) {
  var $root = ($scope && $scope.length) ? $scope : $(document);
  $root.find('[data-bs-toggle="tooltip"]').each(function () {
    Tooltip.getInstance(this) || new Tooltip(this, { container: 'body' });
  });
}

function getSelect2DisplayTitle($select, $rendered) {
  var val = $select.val();
  if (val) {
    var optText = ($select.find('option:selected').first().text() || '').trim();
    if (optText && optText !== SELECT2_PLACEHOLDER) return optText;
  }

  var title = ($rendered.attr('title') || '').trim();
  if (title && title !== SELECT2_PLACEHOLDER && title !== 'Remove all items') return title;

  var text = $rendered.clone().children().remove().end().text().trim();
  if (text && text !== SELECT2_PLACEHOLDER) return text;
  return '';
}

function syncSelect2Tooltip($select) {
  if (!$select || !$select.length) return;
  var $rendered = $select.next('.select2-container').find('.select2-selection__rendered');
  if (!$rendered.length) return;

  var el = $rendered[0];
  var title = getSelect2DisplayTitle($select, $rendered);

  // Strip native browser tooltips (Select2 re-adds title attributes)
  $rendered.removeAttr('title');
  $rendered.find('[title]').removeAttr('title');
  $select.next('.select2-container').find('.select2-selection').removeAttr('title');

  var existing = Tooltip.getInstance(el);
  if (existing) existing.dispose();

  if (!title) return;
  new Tooltip(el, { container: 'body', title: title, trigger: 'hover' });
}

function initSelect2Tooltips($scope) {
  var $root = ($scope && $scope.length) ? $scope : $('#daily-report-form');
  $root.find('select.select2-hidden-accessible').each(function () {
    syncSelect2Tooltip($(this));
  });
}

// ─── Index filter (list page) ─────────────────────────────────────────────────
function ensureFilterSelectedOptions($el) {
  var selectedId = $el.data('selected-id');
  var selectedText = $el.data('selected-text');
  if (selectedId == null || selectedId === '') return;

  var ids = Array.isArray(selectedId) ? selectedId : [selectedId];
  var texts = Array.isArray(selectedText) ? selectedText : [selectedText];

  ids.forEach(function (id, i) {
    if (id === null || id === undefined || id === '') return;
    var text = texts[i];
    if (!text) return;
    var value = String(id);
    if (isWorkerFilterSelect($el) && value === WORKER_ALL_VALUE && !workerAllOptionAllowed()) return;
    if (!$el.find('option[value="' + value + '"]').length) {
      $el.append(new Option(text, value, true, true));
    }
  });
}

function filterAjaxUrl($el) {
  var $wrap = $('.daily-report-index');
  var urlKey = $el.attr('data-url-key') || $el.data('url-key');
  if (!urlKey || !$wrap.length) return null;
  return $wrap.attr('data-' + urlKey) || $wrap.data(urlKey);
}

function workerAllOptionLabel($el) {
  return $el.attr('data-all-option') || $el.data('allOption') || 'すべて';
}

function isWorkerFilterSelect($el) {
  return $el.attr('id') === 'dr_filter_worker_id';
}

var cachedWorkerDropdownAdapter = null;

// Multi-select hides the inline search field; reuse Select2's single-select
// dropdown search so 作業者 can still be filtered by name.
function workerFilterDropdownAdapter() {
  if (cachedWorkerDropdownAdapter) return cachedWorkerDropdownAdapter;

  var amd = $.fn.select2 && $.fn.select2.amd;
  if (!amd || typeof amd.require !== 'function') return null;

  try {
    var Utils = amd.require('select2/utils');
    var Dropdown = amd.require('select2/dropdown');
    var DropdownSearch = amd.require('select2/dropdown/search');
    var CloseOnSelect = amd.require('select2/dropdown/closeOnSelect');
    var AttachBody = amd.require('select2/dropdown/attachBody');

    var Adapter = Utils.Decorate(Dropdown, DropdownSearch);
    Adapter = Utils.Decorate(Adapter, CloseOnSelect);
    Adapter = Utils.Decorate(Adapter, AttachBody);
    cachedWorkerDropdownAdapter = Adapter;
    return Adapter;
  } catch (e) {
    return null;
  }
}

function isDepartmentFilterSelect($el) {
  return $el.attr('id') === 'dr_filter_department_id';
}

function workerAllOptionAllowed() {
  return !selectedDepartmentId();
}

function prependWorkerAllToResults(results, text) {
  var normalized = (results || []).filter(function (item) {
    return item && item.id != null && item.id !== '';
  }).map(function (item) {
    return { id: String(item.id), text: item.text == null ? '' : String(item.text) };
  }).filter(function (item) {
    return item.id !== WORKER_ALL_VALUE;
  });
  normalized.unshift({ id: WORKER_ALL_VALUE, text: text || 'すべて' });
  return normalized;
}

function initFilterAjaxSelect($el) {
  if (!$el.length) return;
  var url = filterAjaxUrl($el);
  if (!url) return;

  var placeholder = $el.attr('data-placeholder') || $el.data('placeholder') || '選択してください';
  var wasDisabled = $el.prop('disabled');
  var isMultiple = !!$el.prop('multiple');
  var isWorkerFilter = isWorkerFilterSelect($el);
  var isDepartmentFilter = isDepartmentFilterSelect($el);
  var allOptionText = isWorkerFilter ? workerAllOptionLabel($el) : null;

  $el.off('.drWorkerFilter');
  if ($el.hasClass('select2-hidden-accessible')) $el.select2('destroy');

  ensureFilterSelectedOptions($el);

  $el.prop('disabled', false);

  var select2Options = {
    width: '100%',
    theme: 'bootstrap',
    placeholder: placeholder,
    allowClear: true,
    closeOnSelect: true,
    minimumInputLength: 0,
    ajax: {
      url: url,
      dataType: 'json',
      delay: 250,
      data: function (params) {
        var term = params.term || '';
        if (term === placeholder) term = '';

        var payload = { q: term };
        if (isWorkerFilter) {
          var departmentId = selectedDepartmentId();
          if (departmentId) payload.department_id = departmentId;
        }

        if (isDepartmentFilter) {
          var workerIds = selectedWorkerFilterValues();
          if (workerIds.indexOf(WORKER_ALL_VALUE) === -1 && workerIds.length) {
            payload.worker_id = workerIds;
          }
        }

        return payload;
      },
      processResults: function (data, params) {
        var term = (params && params.term) ? String(params.term).trim() : '';
        var results = [];
        if (Array.isArray(data)) results = data;
        else if (data && Array.isArray(data.results)) results = data.results;

        if (isWorkerFilter && workerAllOptionAllowed() && term === '') {
          results = prependWorkerAllToResults(results, allOptionText);
        }

        return { results: results };
      },
      cache: false
    },
    language: SELECT2_LANGUAGE
  };

  if (isWorkerFilter) {
    var dropdownAdapter = workerFilterDropdownAdapter();
    if (dropdownAdapter) {
      select2Options.dropdownAdapter = dropdownAdapter;
    }

    select2Options.templateResult = function (item) {
      if (item.loading) return item.text;
      if (String(item.id) === WORKER_ALL_VALUE) {
        return $('<span class="dr-worker-all-option"></span>').text(item.text);
      }
      return item.text;
    };
  }

  $el.select2(select2Options);

  if (isWorkerFilter && !workerAllOptionAllowed()) {
    $el.find('option[value="' + WORKER_ALL_VALUE + '"]').remove();
  }

  if (isWorkerFilter || isDepartmentFilter) {
    $el.on('select2:open.drWorkerFilter', function () {
      window.setTimeout(function () {
        var $dropdown = $('.select2-container--open .select2-dropdown');
        if (isWorkerFilter) $dropdown.addClass('dr-worker-filter-dropdown');

        var $dropdownSearch = $dropdown.find('.select2-search--dropdown .select2-search__field');
        var $search = $dropdownSearch.length
          ? $dropdownSearch
          : $el.next('.select2-container').find('.select2-search__field');
        if (!$search.length) return;

        if (isWorkerFilter && !$search.attr('placeholder')) {
          $search.attr('placeholder', '検索');
        }
        $search.trigger('focus').trigger('input');
      }, 0);
    });
  }

  if (wasDisabled) $el.prop('disabled', true);
}

function selectedDepartmentId() {
  return $('#dr_filter_department_id').val() || '';
}

function selectedWorkerFilterValues() {
  var $worker = $('#dr_filter_worker_id');
  var vals = $worker.val() || [];
  if (!Array.isArray(vals)) vals = vals ? [vals] : [];
  return vals.filter(function (value) {
    return value !== null && value !== undefined && value !== '';
  });
}

function shouldLockDepartmentByWorkers() {
  var vals = selectedWorkerFilterValues();
  return vals.indexOf(WORKER_ALL_VALUE) !== -1 || vals.length >= 2;
}

function setDepartmentFilterDisabled(disabled) {
  var $dept = $('#dr_filter_department_id');
  if (!$dept.length) return;
  if ($dept.prop('disabled') === !!disabled) return;

  ignoringDepartmentChange = true;
  $dept.prop('disabled', !!disabled);
  if ($dept.hasClass('select2-hidden-accessible')) {
    $dept.trigger('change.select2');
  }
  ignoringDepartmentChange = false;
}

var ignoringDepartmentChange = false;

function syncDepartmentFieldWithWorkers() {
  var $dept = $('#dr_filter_department_id');
  if (!$dept.length) return;

  if (shouldLockDepartmentByWorkers()) {
    if ($dept.val()) $dept.val(null);
    setDepartmentFilterDisabled(true);
    return;
  }

  // 1 worker: keep 部署 — that department belongs to the selected worker
  setDepartmentFilterDisabled(false);
}

function refreshWorkerFilterForDepartment() {
  if (ignoringDepartmentChange) return;
  var $worker = $('#dr_filter_worker_id');
  if (!$worker.length || $worker.prop('disabled')) return;
  if (shouldLockDepartmentByWorkers()) return;

  if (selectedDepartmentId()) {
    $worker.find('option[value="' + WORKER_ALL_VALUE + '"]').remove();
    var specificWorkers = selectedWorkerFilterValues().filter(function (value) {
      return String(value) !== WORKER_ALL_VALUE;
    });
    // Keep a single selected worker — that worker belongs to the chosen department
    if (specificWorkers.length !== 1) {
      $worker.val(null).trigger('change');
    }
  }
  initFilterAjaxSelect($worker);
}

function bindDepartmentWorkerFilter() {
  var $dept = $('#dr_filter_department_id');
  if (!$dept.length) return;

  $dept.on('change', refreshWorkerFilterForDepartment);
}

function bindWorkerAllOptionExclusive() {
  var $worker = $('#dr_filter_worker_id');
  if (!$worker.length) return;

  var syncing = false;
  $worker.on('change', function () {
    if (!syncing) {
      var vals = selectedWorkerFilterValues();
      if (vals.indexOf(WORKER_ALL_VALUE) !== -1 && vals.length >= 2) {
        var last = vals[vals.length - 1];
        var next = last === WORKER_ALL_VALUE
          ? [WORKER_ALL_VALUE]
          : vals.filter(function (value) { return value !== WORKER_ALL_VALUE; });

        syncing = true;
        $worker.val(next).trigger('change.select2');
        syncing = false;
      }
    }

    // Lock 部署 when すべて or 2+ workers; keep it when 1 worker is selected
    syncDepartmentFieldWithWorkers();
  });
}

function currentAggregationType() {
  return ($('#dr_aggregation_type').val() || '').toString();
}

function resolvedAggregationType() {
  return currentAggregationType() || 'by_self';
}

function selectWorkerAllValue($worker) {
  if (!workerAllOptionAllowed()) return;

  var label = workerAllOptionLabel($worker);
  if (!$worker.find('option[value="' + WORKER_ALL_VALUE + '"]').length) {
    $worker.prepend(new Option(label, WORKER_ALL_VALUE, true, true));
  }
  $worker.val([WORKER_ALL_VALUE]).trigger('change');
}

function syncAggregationTypeWithSelfCheckbox() {
  var $agg = $('#dr_aggregation_type');
  if (!$agg.length) return;

  var current = $agg.val() || '';
  if ($('#dr_current_worker_id').is(':checked')) {
    if (current !== 'by_self') {
      $agg.val('by_self').trigger('change');
    }
  } else if (current === 'by_self') {
    $agg.val('').trigger('change');
  }
}

function syncWorkerFieldWithSelfCheckbox(options) {
  var $self = $('#dr_current_worker_id');
  var $worker = $('#dr_filter_worker_id');
  if (!$self.length || !$worker.length) return;

  if ($self.is(':checked')) {
    $worker.val(null).trigger('change');
    $worker.prop('disabled', true);
    if ($worker.hasClass('select2-hidden-accessible')) {
      $worker.trigger('change.select2');
    }
  } else {
    $worker.prop('disabled', false);
    initFilterAjaxSelect($worker);
    if (options && options.selectAll) selectWorkerAllValue($worker);
  }

  syncDepartmentFieldWithWorkers();
}

function clearHiddenFilterField($row) {
  $row.find('input[type="text"]').val('');
  $row.find('input[type="checkbox"]').prop('checked', false);

  $row.find('select').each(function () {
    var $select = $(this);
    $select.prop('disabled', false);
    $select.val(null).trigger('change');
    if ($select.hasClass('select2-hidden-accessible')) {
      $select.trigger('change.select2');
    }
  });

  syncWorkerFieldWithSelfCheckbox();
}

function isCaseAggregationType(type) {
  return type === 'by_case_worker' || type === 'by_case_project';
}

function isWorkerAggregationType(type) {
  return type === 'by_worker';
}

function repositionAggregationField() {
  var type = resolvedAggregationType();
  var $row = $('#dr-aggregation-type-row');
  if (!$row.length) return;

  var $label = $row.find('.dr-aggregation-label');
  var $input = $row.find('.dr-aggregation-input');

  if (isWorkerAggregationType(type)) {
    $('#dr-aggregation-slot-worker').append($row);
    $label.removeClass('col-3 col-5 col-md-5').addClass('col-4');
    $input.removeClass('col-7 col-md-7 col-8').addClass('col-8');
  } else if (isCaseAggregationType(type)) {
    $('#dr-aggregation-slot-compact').append($row);
    $label.removeClass('col-3 col-5 col-md-5').addClass('col-4');
    $input.removeClass('col-7 col-md-7 col-8').addClass('col-8');
  } else {
    $('#dr-aggregation-slot-default').append($row);
    $label.removeClass('col-3 col-4').addClass('col-5 col-md-5');
    $input.removeClass('col-8').addClass('col-7 col-md-7');
  }
}

function applyFilterFieldCols($field, labelCol, inputCol) {
  var $label = $field.find('.dr-filter-label');
  var $input = $field.find('.dr-filter-input');
  $label.removeClass('col-3 col-5').addClass(labelCol);
  $input.removeClass('col-7 col-8').addClass(inputCol);
}

function repositionClientPjFields() {
  var type = resolvedAggregationType();
  var $pj = $('#dr-filter-field-pj');
  var $client = $('#dr-filter-field-client');
  var $slotCol1 = $('#dr-filter-slot-col1-second');
  var $slotCol3 = $('#dr-filter-slot-col3-first');
  if (!$pj.length || !$client.length || !$slotCol1.length || !$slotCol3.length) return;

  if (type === 'by_case_project' || type === 'by_case_worker') {
    // 顧客名 in col1 (PJ's default slot), PJ名 in col3 (client's default slot)
    $slotCol1.append($client);
    $slotCol3.append($pj);
    applyFilterFieldCols($client, 'col-5', 'col-7');
    applyFilterFieldCols($pj, 'col-3', 'col-8');
  } else {
    $slotCol1.append($pj);
    $slotCol3.append($client);
    applyFilterFieldCols($pj, 'col-5', 'col-7');
    applyFilterFieldCols($client, 'col-3', 'col-8');
  }
}

function toggleAggregationFilterFields() {
  var type = resolvedAggregationType();
  var hideCase = isCaseAggregationType(type);
  var hideWorker = isWorkerAggregationType(type);

  $('.dr-filter-field').each(function () {
    var $field = $(this);
    var hideForCase = $field.attr('data-dr-hide-when-case-aggregation') === '1';
    var hideForWorker = $field.attr('data-dr-hide-when-worker-aggregation') === '1';
    var shouldHide = (hideForCase && hideCase) || (hideForWorker && hideWorker);

    $field.toggle(!shouldHide);
    if (shouldHide) clearHiddenFilterField($field);
  });

  if (hideWorker) {
    $('#dr_current_worker_id').prop('checked', false);
    $('#dr_filter_worker_id').prop('disabled', false);
    initFilterAjaxSelect($('#dr_filter_worker_id'));
  } else {
    syncWorkerFieldWithSelfCheckbox();
  }

  repositionAggregationField();
  repositionClientPjFields();
  syncDepartmentFieldWithWorkers();

  var $agg = $('#dr_aggregation_type');
  if ($agg.length && !$agg.val() && $agg.hasClass('select2-hidden-accessible')) {
    $agg.val(null).trigger('change.select2');
  }
}

$(document).ready(function () {
  if (!$('.daily-report-index').length) return;

  // AJAX select2 for filter droplists (limit 50 + search via endpoints)
  $('.daily-report-index .dr-filter-ajax').each(function () {
    initFilterAjaxSelect($(this));
  });

  bindWorkerAllOptionExclusive();
  bindDepartmentWorkerFilter();

  // 自分 checkbox ↔ 作業者 / 表示する集計結果
  syncWorkerFieldWithSelfCheckbox();
  $('#dr_current_worker_id').on('change', function () {
    syncAggregationTypeWithSelfCheckbox();
    syncWorkerFieldWithSelfCheckbox({ selectAll: !$(this).is(':checked') });
  });

  toggleAggregationFilterFields();
  $('select[name="aggregation_type"]').on('change', toggleAggregationFilterFields);
  $('#dr_aggregation_type').on('select2:clear', function () {
    // Keep blank after clicking ×; blank is treated as by_self
    $(this).val('');
  });

  // Disabled worker select is not submitted — clear worker_id when 自分 is checked
  $('#dr-filter-form').on('submit', function () {
    var $agg = $('#dr_aggregation_type');
    if ($agg.length && !$agg.val()) {
      if (!$agg.find('option[value=""]').length) {
        $agg.prepend(new Option('', '', true, true));
      }
      $agg.val('');
    }
    if ($('#dr_current_worker_id').is(':checked')) {
      $('#dr_filter_worker_id').prop('disabled', false).val(null).prop('disabled', true);
    }
  });

  initDailyReportTooltips($('.daily-report-index'));
});

function formatCaseDetailHours(minutes) {
  var total = parseInt(minutes, 10) || 0;
  var hours = Math.floor(total / 60);
  var mins = total % 60;
  return hours + '時間 ' + String(mins).padStart(2, '0') + '分';
}

function applyCaseDetailTab($page, key) {
  var visibleMinutes = 0;
  var visibleCount = 0;
  $page.find('.dr-case-log-row').each(function () {
    var match = key === 'all' || $(this).attr('data-case-key') === key;
    $(this).toggleClass('d-none', !match);
    if (match) {
      visibleCount += 1;
      visibleMinutes += parseInt($(this).attr('data-minutes'), 10) || 0;
    }
  });
  $page.find('.dr-case-log-empty').toggleClass('d-none', visibleCount > 0);
  $page.find('#dr-case-log-total').text(formatCaseDetailHours(visibleMinutes));
  $page.find('.dr-case-tab').each(function () {
    var isActive = $(this).attr('data-case-tab') === key;
    $(this).toggleClass('is-active', isActive);
    $(this).toggleClass('is-blue', !isActive);
  });
  $page.find('#dr-case-tab-input').val(key);

  if (window.history && window.history.replaceState) {
    var url = new URL(window.location.href);
    if (key === 'all') url.searchParams.delete('tab');
    else url.searchParams.set('tab', key);
    window.history.replaceState({}, '', url);
  }
}

// The detail page hides the button that opens this modal. Keep the init until that control returns.
function initCaseDetailSwitch($page) {
  var $modal = $('#dr-switch-case-modal');
  var $select = $('#dr-switch-project');
  if (!$modal.length || !$select.length || $select.data('switchReady')) return;
  $select.data('switchReady', true);

  $modal.on('shown.bs.modal', function () {
    if ($select.hasClass('select2-hidden-accessible')) return;
    $select.select2({
      width: '100%',
      theme: 'bootstrap',
      placeholder: $select.data('placeholder') || '案件を選択してください',
      allowClear: true,
      dropdownParent: $modal,
      ajax: {
        url: $page.attr('data-projects-url'),
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return { q: params.term || '' };
        },
        processResults: function (data) {
          var results = Array.isArray(data) ? data : ((data && data.results) || []);
          return {
            results: results.map(function (item) {
              return { id: item.id, text: item.text || item.name };
            })
          };
        }
      },
      language: SELECT2_LANGUAGE
    });
  });

  $('#dr-switch-case-submit').on('click', function () {
    var projectId = $select.val();
    if (!projectId) return;
    var url = new URL(window.location.href);
    url.searchParams.set('project_id', projectId);
    url.searchParams.delete('tab');
    url.searchParams.delete('source_type');
    url.searchParams.delete('source_id');
    url.searchParams.delete('worker_id');
    window.location = url.toString();
  });
}

$(document).ready(function () {
  var $page = $('.dr-case-detail');
  if (!$page.length) return;

  initDailyReportTooltips($page);
  applyCaseDetailTab($page, $page.attr('data-active-tab') || 'all');
  initCaseDetailSwitch($page);

  $page.on('click', '.dr-case-tab', function () {
    applyCaseDetailTab($page, $(this).attr('data-case-tab') || 'all');
  });

});
